import axios from "axios"
import { onlineStatusLDURL } from "./apiDomain"

export default {
    checkOnline: async (id) => {
        try {
            let resp = await axios.get(onlineStatusLDURL, {
                params: {
                    id
                }
            })
            return !!resp.data.online
        } catch (e) {
            console.log(e)
            throw new Error('onlineStatus error : ', { cause: e })
        }
    }
}
